import BaseService from './BaseService';
import entities from 'src/config/entities'
import axios from "axios";

class EmailTemplateService extends BaseService{

  constructor() {
    super({ entity: entities.EMAIL });
  }

  async sendTestEmail(emailId, data) {
    try {
      return await axios.post(`emails/${emailId}/test`, data);
    } catch (e) {
      this._handleError({ translationKey: 'settings.email.sendTest.error', error: e });
      throw e;
    }
  }


}

export default new EmailTemplateService();
